import type { BannerEvent, BannerType } from '@lt/api/dist/methods/stats/types';

export const SHOW_BANNER: BannerEvent['SHOW_BANNER'] = 'show_banner';
export const CLOSE_BANNER: BannerEvent['CLOSE_BANNER'] = 'close_banner';
export const CLICK_ON_BANNER: BannerEvent['CLICK_ON_BANNER'] =
  'click_on_banner';
export const MOBILE_BANNER_TO_APP: BannerType['MOBILE_BANNER_TO_APP'] =
  'mobile_banner_to_app';
